import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useHistory } from "react-router-dom";
import "./SignUpSuccess.scss";
import ContentContainer from "../common/ContentContainer";
import GuestContainer from "./GuestContainer";

const SignUpSuccess = () => {
  const history = useHistory();
  useEffect(() => {
    setTimeout(() => {
      history.push("/login");
    }, 2000);
  }, []);
  return (
    <>
      <GuestContainer >
      <div className="login-content-wrapper signup-content-wrapper">
          <div className="login-content signup-content">
          <Col className="signup-success-col">
          <div className="p-4">
                <h4 className="text-center">Your account has been verified!</h4>
                <p>Redirecting...</p>
                <i
                  className="far fa-check-circle my-3 text-success"
                  style={{ fontSize: 150 }}
                ></i>
             </div>
          </Col>
        </div>
        </div>
      </GuestContainer>
    </>
  );
};

export default SignUpSuccess;
